import styled from 'styled-components';

export const ModalTitle = styled.strong`
  width: 100%;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #ffffff;
`;

export const ModalText = styled.p`
  margin-top: 16px;
  font-weight: 500;
  text-align: center;
  line-height: 24px;
`;
